import { action, makeObservable, observable } from 'mobx'
import Store from './Store'
import { ProviderAutomation } from '../providers/types'
import { v4 as uuidv4 } from 'uuid'
import type AutomationCollection from './AutomationCollection'

export default class Automation {
  id = ''
  name = ''
  day = ''
  hour = ''
  templateId = ''
  created_at: Date
  store: Store
  collection?: AutomationCollection

  constructor(store: Store, collection?: AutomationCollection) {
    makeObservable(this, {
      name: observable,
      day: observable,
      hour: observable,
      templateId: observable,
      created_at: false,
      update: action,
      fromProvider: action,
    })
    this.id = uuidv4()
    this.created_at = new Date()
    this.store = store
    this.collection = collection
  }

  fromProvider = (data: ProviderAutomation) => {
    this.id = data.id
    this.name = data.name
    this.day = data.day
    this.hour = data.hour
    this.templateId = data.templateId
  }

  async create() {
    return this.store.provider
      .createAutomation({
        id: this.id,
        name: this.name,
        day: this.day,
        hour: this.hour,
        templateId: this.templateId,
      })
      .then((template) => this.fromProvider(template))
      .catch((e) => {
        // this.setLastError("Failed to create")
        throw e
      })
      .finally(() => {
        // this.setSaving(false)
      })
  }

  async update(payload: {
    name: string
    day: string
    hour: string
    templateId: string
  }) {
    this.name = payload.name
    this.day = payload.day
    this.hour = payload.hour
    this.templateId = payload.templateId
    return this.store.provider
      .updateAutomation(this.id, {
        name: this.name,
        day: this.day,
        hour: this.hour,
        templateId: this.templateId,
      })
      .then((template) => this.fromProvider(template))
      .catch((e) => {
        // this.setLastError("Failed to create")
        throw e
      })
      .finally(() => {
        // this.setSaving(false)
      })
  }

  async delete() {
    this.collection?.remove(this.id)
    return this.store.provider
      .deleteAutomation(this.id)
      .catch((e) => {
        // this.setLastError("Failed to create")
        throw e
      })
      .finally(() => {
        // this.setSaving(false)
      })
  }
}
